var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _vm.mode !== "delete"
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input":
                          _vm.$v.confirm_reason.title_start_date.$error
                      }
                    },
                    [
                      _c("label", { staticClass: "form__label" }, [
                        _vm._v("Effective Start Date "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("j-datepicker", {
                        attrs: {
                          "disabled-dates": _vm.disabledStartDate(
                            _vm.confirm_reason.title_end_date
                          ),
                          disabled: false,
                          format: "MMM dd, yyyy",
                          placeholder: "Jan 01, 2020"
                        },
                        model: {
                          value: _vm.$v.confirm_reason.title_start_date.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.confirm_reason.title_start_date,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.confirm_reason.title_start_date.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode !== "delete"
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input":
                          _vm.$v.confirm_reason.title_end_date.$error
                      }
                    },
                    [
                      _c("label", { staticClass: "form__label" }, [
                        _vm._v("Effective End Date")
                      ]),
                      _vm._v(" "),
                      _c("j-datepicker", {
                        attrs: {
                          "disabled-dates": _vm.disabledEndDate(
                            _vm.confirm_reason.title_start_date
                          ),
                          disabled: false,
                          format: "MMM dd, yyyy",
                          placeholder: "Jan 01, 2020"
                        },
                        model: {
                          value: _vm.$v.confirm_reason.title_end_date.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.confirm_reason.title_end_date,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.confirm_reason.title_end_date.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "delete"
            ? _c("b-col", { attrs: { md: "12" } }, [
                _c("h6", { staticClass: "text-center" }, [
                  _vm._v("Are you sure want to delete this information?")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  class: { "error-input": _vm.$v.confirm_reason.reasons.$error }
                },
                [
                  _c("label", { staticClass: "form__label" }, [
                    _vm._v("Reason "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("j-textarea", {
                    attrs: { placeholder: "Write reason here" },
                    model: {
                      value: _vm.$v.confirm_reason.reasons.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.confirm_reason.reasons, "$model", $$v)
                      },
                      expression: "$v.confirm_reason.reasons.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "float-right m__t--20" },
              [
                _c(
                  "b-button",
                  { staticClass: "btn grey", on: { click: _vm.closeModal } },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _vm.mode === "delete"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn red",
                        on: { click: _vm.updateReasons }
                      },
                      [_vm._v("Yes")]
                    )
                  : _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.updateReasons }
                      },
                      [_vm._v("Update")]
                    )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bf0b784", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf0b784","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/assignment/jModalConfirmWithReason.vue
// module id = null
// module chunks = 